app.filter("medicalType", function() {
    return function(input){
        medicalType = {
			"0": "その他",
			"1": "国保・特定健診",
			"2": "社保・定期健診",
			"3": "食の臨床試験"
		}
        return medicalType[input];
    }
});
